const rZasielkovna = {
    apiKey: null,
    options: null,
    openModal(_target) {
        const vendorsEl = document.querySelector('.shopping-modules__item[data-vendors]');
        const parsedVendors = vendorsEl ? JSON.parse(vendorsEl.dataset.vendors) : [];
        const formattedVendors = parsedVendors && parsedVendors.length ? parsedVendors.map(vendor => ({carrierId: vendor})) : [{country: "hu", group: "zbox", selected: true},{ country: "hu", selected: true}];

        Packeta.Widget.pick(
            this.apiKey,
            data => {
                this.processSelectedBranch(data);
            },
            {
                // ISO 639-1 code
                language: Eshop.options.locale
                    ? Eshop.options.locale.split('_')[0]
                    : 'sk',
                country: Eshop.options.locale
                    ? Eshop.options.locale.split('_')[1].toLowerCase()
                    : 'sk',
                vendors: [
                    ...formattedVendors,
                ],
                ...this.options,
            }
        );
    },
    processSelectedBranch(data) {
        if (!data) {
            return;
        }

        document
            .querySelector('[r-zasielkovna-holder]')
            .classList.add('is-loading');
        document
            .querySelector('[r-zasielkovna-empty]')
            .classList.remove('hidden');
        document
            .querySelector('[r-zasielkovna-selected]')
            .classList.add('hidden');
        document.querySelector(
            'input[name="shipping_module_id"][r-zasielkovna-input]'
        ).value = null;

        $.post(
            '/create-zasielkovna-branch',
            data,
            response => {
                if (!response.status) {
                    this.failedCallback();

                    return false;
                }

                data.id = response.data.id;

                this.successCallback(data);
            },
            'json'
        ).fail(() => {
            console.error(error);
            this.failedCallback();
        });
    },
    failedCallback() {
        document
            .querySelector('#error-create-branch')
            .classList.remove('is-hidden');
        document.querySelector(
            'input[name="shipping_module_id"][r-zasielkovna-input]'
        ).value = null;
        document
            .querySelector("[r-zasielkovna-holder]")
            .classList.remove("is-loading");
    },
    successCallback(data) {
        document.querySelector(
            'input[name="shipping_module_id"][r-zasielkovna-input]'
        ).value = data.id;
        document.querySelector('input[name="shipping_name"]').value = data.name;
        document.querySelector('input[name="shipping_address"]').value =
            data.street;
        document.querySelector('input[name="shipping_post_code"]').value =
            data.zip;
        document.querySelector('input[name="shipping_city"]').value = data.city;

        document
            .querySelector("[r-zasielkovna-selected]")
            .classList.remove("hidden");
        document.querySelector("[r-zasielkovna-selected-branch]").innerText =
            data.place;
        document.querySelector("[r-zasielkovna-selected-address]").innerText =
            data.name;
        document.querySelector("[r-zasielkovna-empty]").classList.add('hidden');
        document
            .querySelector('[r-zasielkovna-holder]')
            .classList.remove('is-loading');
        document
            .querySelector('#error-create-branch')
            .classList.add('is-hidden');

        document.getElementById('error-branch').style.display = 'none';
        window.updateObjednavky();
    },
    init(apiKey, options = {}) {
        if (!apiKey) {
            console.error('apiKey is not defined');

            return;
        }

        this.apiKey = apiKey;
        this.options = options;

        setTimeout(() => {
            document
                .querySelector('[r-zasielkovna-empty]')
                .closest('.shopping-modules__item')
                .addEventListener('click', event => {
                    if (
                        !document
                            .querySelector('[r-zasielkovna-empty]')
                            .classList.contains('hidden')
                    ) {
                        this.openModal(event.currentTarget);
                    }
                });
        }, 100);

        for (const trigger of document.querySelectorAll(
            '[r-zasielkovna-trigger]'
        )) {
            trigger.addEventListener('click', event => {
                this.openModal(event.currentTarget);
            });
        }
    },
};

$(function() {
    if (
        document.querySelector(
            'input[name="shipping_module_id"][r-zasielkovna-input]'
        )
    ) {
        let options = {};

        if (
            document.querySelector(
                'input[name="shipping_module_id"][r-zasielkovna-input]'
            ).dataset['onlyLive'] === '1'
        ) {
            options.livePickupPoint = true;
        }

        rZasielkovna.init('9c896164053e55f2', options);
    }
});
